import { MouseEventHandler, memo } from "react"
import { RefObject } from "react"

interface AutoCompleteSuggestionsProps {
    suggestions: string[]
    showSuggestions: boolean
    activeIdx: number
    onSuggestionClick: (idx: number) => MouseEventHandler<HTMLLIElement>
    suggestionsRef?: RefObject<HTMLUListElement | null>
}

const AutoCompleteSuggestionsComponent = ({
    suggestions,
    showSuggestions,
    activeIdx,
    onSuggestionClick,
    suggestionsRef
}: AutoCompleteSuggestionsProps) => {
    if (!showSuggestions) {
        return null
    }

    return (
        <ul
            className="ac-suggestions"
            ref={suggestionsRef}
            role="listbox"
            aria-label="Autocomplete suggestions"
        >
            {suggestions.map((w, idx) => (
                <li
                    key={`${w}-${idx}`} // Better key to handle duplicate suggestions
                    className={idx === activeIdx ? "active" : ""}
                    onMouseDown={onSuggestionClick(idx)}
                    role="option"
                    aria-selected={idx === activeIdx}
                    id={`suggestion-${idx}`}
                >
                    {w}
                </li>
            ))}
        </ul>
    )
}

export const AutoCompleteSuggestions = memo(AutoCompleteSuggestionsComponent)
